import React, { useEffect, useState } from "react";
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import LinktreeLinkListItem from "./LinktreeLinkListItem";

const SortableLinkItem = ({ link, onClickDelete, onToggleActive }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: link.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    marginBottom: "2.5rem",
    cursor: "grab",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <LinktreeLinkListItem {...link} onClickDelete={onClickDelete} onToggleActive={onToggleActive} />
    </div>
  );
};

const LinktreeLinksDraggable = ({ links, onClickDelete, onOrderChange, onToggleActive }) => {
  const [items, setItems] = useState([...links]);

  useEffect(() => {
    setItems([...links]);
  }, [links]);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const oldIndex = items.findIndex(i => i.id === active.id);
      const newIndex = items.findIndex(i => i.id === over.id);
      const newItems = arrayMove(items, oldIndex, newIndex);
      setItems(newItems);
      if (onOrderChange) onOrderChange(newItems);
    }
  };

  return (
    <>
      {items.length === 0 ? (
        <p style={{ opacity: 0.6 }}>Keine Links vorhanden</p>
      ) : (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext items={items.map(i => i.id)} strategy={verticalListSortingStrategy}>
            {items.map(link => (
              <SortableLinkItem key={link.id} link={link} onClickDelete={onClickDelete} onToggleActive={onToggleActive} />
            ))}
          </SortableContext>
        </DndContext>
      )}
    </>
  );
};

export default LinktreeLinksDraggable;
